/**
 * 会员认证状态
 */
export enum MemberStatus {
  UNVERIFIED = 0,
  PENDING = 1,
  SUCCESS = 2,
  FAIL = 3,
  EXPIRED = 4
}

export const MemberStatusTextMap: Record<
  MemberStatus,
  {
    text: string
    color: string
  }
> = {
   [MemberStatus.UNVERIFIED]: { text: '未认证', color: 'orange' },
   [MemberStatus.PENDING]: { text: '认证中', color: 'blue' },
   [MemberStatus.SUCCESS]: { text: '认证成功', color: 'green' },
   [MemberStatus.FAIL]: { text: '认证失败', color: 'red' },
   [MemberStatus.EXPIRED]: { text: '认证过期', color: 'red' }
}

export const getMemberStatusTextMap = (memberStatus : string | number = MemberStatus.UNVERIFIED) => {
  return MemberStatusTextMap[memberStatus as MemberStatus]
}
